export default __webpack_public_path__ + "static/email-icon-6eb1e7a7549fd31cc3b34f2911f27e74.svg";